export default __webpack_public_path__ + "static/logo-complet-white-text-dd3b3cd24a7b6e5d17636718e4329252.svg";